import { isMediumUI } from 'shared/app/lib/choose-ui-type';
import { removeNulls } from 'utils';
export function sortDashboardUISettings(ui_settings, next_ui_settings) {
    return Number(ui_settings.id) - Number(next_ui_settings.id);
}
export function getDashboardUISettings(initial_dashboard_ui_settings, devices_ids) {
    const dashboard_ui_settings = removeNulls(devices_ids)
        .sort((id, next_id) => id - next_id)
        .map((device_id, index) => {
        const device_dashboard_ui_settings = initial_dashboard_ui_settings[device_id];
        const medium_ui_x = index % 2 === 0 ? 0 : 6;
        const { x = isMediumUI() ? medium_ui_x : 0, y = 0, width = isMediumUI() ? 6 : 12, position = index, height = 12, pinned = false, } = device_dashboard_ui_settings || {};
        return [
            device_id,
            {
                id: device_id.toString(),
                x,
                y,
                width,
                height,
                pinned,
                position,
            },
        ];
    });
    return Object.fromEntries(dashboard_ui_settings);
}
